import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { Communication } from "../../common/models/communication";
import { AthleteCoach } from "../../common/models/athlete-coach";
import { OrganizationMembership } from "../../common/models/organization-membership";
import { Coach } from "../../common/models/coach";
import { Athlete } from "../../common/models/athlete";

export class CommunicationRights {
    public Ready: Promise<boolean> = new Promise((resolve, reject) => resolve(false));
    private _itemRightsList: CommunicationItemRightsList | null = null;
    private _screenRightsList: CommunicationScreenRightList | null = null;
    private _paramsItem: CommunicationItemRightsParams | null = null;
    private _paramsScreen: CommunicationScreenRightsParams | null = null;
    private _bestOfItemRight = 10000;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }

    public evaluateItemRight(params: CommunicationItemRightsParams): void {

        /**
         * Les paramètres reçus contiennent le athlete, le user.id
         * et le organizationId. Les droits évalués doivent répondrent
         * à la question : qu'est-ce que je (user.id) peux faire avec
         * cet athlète (athlete.id) dans cette organisation (organizationId)
         * avec mon rôle (this._bestOfItemRight).
         */

        this._paramsItem = params;
        this.setDefault();
        this.setBestOfRole();

        const athlete = this._paramsItem.athlete;
        const communication = this._paramsItem.communication;

        if(!this._itemRightsList) throw new Error('ItemRightsList is null');

        switch (this._bestOfItemRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            // toutes les communications
            this._itemRightsList.view = true;
            this._itemRightsList.edit = true;
            this._itemRightsList.delete = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un supercoach
            // toutes les communications des athlètes de son organisation
            const memberships = this._utils.findManyIn([athlete.userId], this._paramsItem.athleteMemberships, 'userId');
            const orgIds = this._utils.getKeyValues(memberships, 'organizationId');

            if (orgIds.indexOf(this._paramsItem.organizationId) > -1) {
                this._itemRightsList.view = true;
                this._itemRightsList.edit = true;
                this._itemRightsList.delete = true;
            }
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            // toutes les communications des athlètes ayant une relation avec lui
            const links = this._utils.findManyIn([athlete.id], this._paramsItem.athleteCoachRelations, 'athleteId');
            const coachIds = this._utils.getKeyValues(links, 'coachId');
            const me = this._utils.findIn(this._paramsItem.user.id, this._paramsItem.coaches, 'userId');

            if (coachIds.indexOf(me.id) > -1) {
                this._itemRightsList.view = true;
                this._itemRightsList.edit = true;
                this._itemRightsList.delete = true;
            }
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            // uniquement mes communications
            this._itemRightsList.view = (this._paramsItem.user.id === athlete.userId);
            this._itemRightsList.edit = (this._paramsItem.user.id === athlete.userId);
            this._itemRightsList.delete = (this._paramsItem.user.id === athlete.userId);
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            // aucun
            break;

        default:
            // rien
        }
    }

    public evaluateScreenRights(params: CommunicationScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();

        if(!this._screenRightsList) throw new Error('ScreenRightsList is null');
        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.list = false;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        default:
            // rien
        }
    }

    public getItemRightsList(): CommunicationItemRightsList {
        if(!this._itemRightsList) throw new Error('ItemRightsListghtsList is null');
        return this._itemRightsList;
    }

    public getScreenRightsList(): CommunicationScreenRightList {
        if(!this._screenRightsList) throw new Error('ScreenRightsList is null');
        return this._screenRightsList;
    }

    public getItemParams(): CommunicationItemRightsParams {
        if(!this._paramsItem) throw new Error('ParamsItem is null');
        return this._paramsItem;
    }

    public getScreenParams(): CommunicationScreenRightsParams {
        if(!this._paramsScreen) throw new Error('ParamsScreen is null');
        return this._paramsScreen;
    }

    public get LIST() {
        if (this._screenRightsList) {
            return this._screenRightsList.list;
        }
        return false;
    }

    public get ADD() {
        if (this._screenRightsList) {
            return this._screenRightsList.add;
        }
        return false;
    }

    public get EDIT() {
        if (this._screenRightsList) {
            return this._screenRightsList.edit;
        }
        return false;
    }

    public get DELETE() {
        if (this._screenRightsList) {
            return this._screenRightsList.delete;
        }
        return false;
    }

    private setDefault(): void {

        const defaultItemRights: CommunicationItemRightsList = {
            view: false,
            edit: false,
            delete: false,
        };
        this._itemRightsList = defaultItemRights;

        const defaultScreenRights: CommunicationScreenRightList = {
            list: false,
            add: false,
            edit: false,
            delete: false,
        };
        this._screenRightsList = defaultScreenRights;

        this._bestOfItemRight = 10000;
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
                if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
                    this._bestOfItemRight = this._paramsItem.rolesIds[i];
                }
            }
        }

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}

export interface CommunicationItemRightsList {
    view: boolean;
    edit: boolean;
    delete: boolean;
}

export interface CommunicationScreenRightList {
    list: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
}

export interface CommunicationItemRightsParams {
    user: User;
    organizationId: number;
    communication: Communication;
    rolesIds: number[];
    athleteCoachRelations: AthleteCoach[];
    athleteMemberships: OrganizationMembership[];
    coaches: Coach[];
    athlete: Athlete;
}

export interface CommunicationScreenRightsParams {
    rolesIds: number[];
}
